export default "__VITE_ASSET__9c335113__"